// extracted by css-extract-rspack-plugin
export default {"logUpload":"kyKPzfmK25kQ6s73","logo":"M1tdMWYcgsB_Qn38","options":"x71x4FA_g0E5iHmP","removeLogoButtonText":"KB6TrGbMDQnncK4S","recommendationText":"yvCjPzPsEBknMlA1"};